import axios from 'axios';

const isProduction = true;

export const baseURL = isProduction
  ? (process.env.REACT_APP_API_URL 
      || `https://api.${window.location.host.replace(/^idzcar\./, '')}`)
  : (process.env.REACT_APP_HML_URL 
      || ".1021motors.com.br/");

const api = axios.create({
  baseURL,
  headers: {
    "Authorization": process.env.REACT_APP_API_KEY
  }
});

export default api;